import { render, staticRenderFns } from "./DatenschutzProtokollReiter.vue?vue&type=template&id=1793e66c"
import script from "./DatenschutzProtokollReiter.vue?vue&type=script&lang=js"
export * from "./DatenschutzProtokollReiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports